var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMusicoboIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 75.08 75.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#09a81b;}.cls-2{fill:#c2c1c1;}.cls-3{fill:#484545;}.cls-4{fill:#dcfd01;}.cls-5{fill:#1be500;}.cls-6{fill:#e50077;}.cls-7{fill:#0097e5;}.cls-8{fill:#838282;}.cls-13,.cls-9{fill:#fff;}.cls-10,.cls-11,.cls-12,.cls-9{stroke:#000;stroke-miterlimit:10;stroke-width:0.25px;}.cls-10{fill:#23d50b;}.cls-11{fill:#0b8bd5;}.cls-12{fill:#d50b8b;}.cls-14{opacity:0.15;}.cls-15{fill:#015603;}.cls-16{fill:#002b01;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_12",
    "data-name": "Layer 12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_9",
    "data-name": "Layer 9"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 37.5,
    cy: 37.5,
    r: 37.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_7",
    "data-name": "Layer 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 21,
    width: 50,
    height: 34,
    rx: 4.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.5,
    y: 22,
    width: 48,
    height: 32,
    rx: 3.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 14.5,
    y: 23,
    width: 46,
    height: 30,
    rx: 2.82
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 19.5,
    cy: 26.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 23.5,
    cy: 26.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 27.5,
    cy: 26.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 31.5,
    cy: 26.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 35,
    y: 25,
    width: 7,
    height: 3,
    rx: 0.94
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_8",
    "data-name": "Layer 8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M18.5,32h4a0,0,0,0,1,0,0V54.63A1.37,1.37,0,0,1,21.13,56H17.87a1.37,1.37,0,0,1-1.37-1.37V34A2,2,0,0,1,18.5,32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M22.5,32h6a0,0,0,0,1,0,0V54.63A1.37,1.37,0,0,1,27.13,56H23.87a1.37,1.37,0,0,1-1.37-1.37V32A0,0,0,0,1,22.5,32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M28.5,32h6a0,0,0,0,1,0,0V54.63A1.37,1.37,0,0,1,33.13,56H29.87a1.37,1.37,0,0,1-1.37-1.37V32A0,0,0,0,1,28.5,32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M34.5,32h6a0,0,0,0,1,0,0V54.63A1.37,1.37,0,0,1,39.13,56H35.87a1.37,1.37,0,0,1-1.37-1.37V32A0,0,0,0,1,34.5,32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M40.5,32h6a0,0,0,0,1,0,0V54.63A1.37,1.37,0,0,1,45.13,56H41.87a1.37,1.37,0,0,1-1.37-1.37V32A0,0,0,0,1,40.5,32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M46.5,32h6a0,0,0,0,1,0,0V54.63A1.37,1.37,0,0,1,51.13,56H47.87a1.37,1.37,0,0,1-1.37-1.37V32A0,0,0,0,1,46.5,32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M52.5,32h4a2,2,0,0,1,2,2V54.63A1.37,1.37,0,0,1,57.13,56H53.87a1.37,1.37,0,0,1-1.37-1.37V32A0,0,0,0,1,52.5,32Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5,32h4a0,0,0,0,1,0,0V45a1,1,0,0,1-1,1h-2a1,1,0,0,1-1-1V32A0,0,0,0,1,20.5,32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5,32h4a0,0,0,0,1,0,0V45a1,1,0,0,1-1,1h-2a1,1,0,0,1-1-1V32a0,0,0,0,1,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5,32h4a0,0,0,0,1,0,0V45a1,1,0,0,1-1,1h-2a1,1,0,0,1-1-1V32a0,0,0,0,1,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5,32h4a0,0,0,0,1,0,0V45a1,1,0,0,1-1,1h-2a1,1,0,0,1-1-1V32a0,0,0,0,1,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5,32h4a0,0,0,0,1,0,0V45a1,1,0,0,1-1,1h-2a1,1,0,0,1-1-1V32a0,0,0,0,1,0,0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 16.22,
    cy: 14.2,
    rx: 5.64,
    ry: 3.19,
    transform: "translate(-5.29 15.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 62.25,
    cy: 59.75,
    rx: 3.18,
    ry: 2.12,
    transform: "translate(-24.02 61.52) rotate(-45)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_10",
    "data-name": "Layer 10",
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M59,7c-3.57-.11-20.84-.24-35,13C6.38,36.47,9.7,60.5,10,63c4,4,18.55,16.82,39,10,6-2,24-9,26-34C75.24,36,76,19,59,7Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_11",
    "data-name": "Layer 11",
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M59,7c10.92,19.3,5,44-10,53s-25.89,9.24-39,3A37.36,37.36,0,0,0,38,75c18.21-.31,29-14,30-16a37.61,37.61,0,0,0,7-23C74.29,18.44,60.82,8.32,59,7Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicoboIcon);
export default __webpack_public_path__ + "static/media/musicobo-icon.207e7f1b9c44cd7fd67021adeea310e0.svg";
export { ForwardRef as ReactComponent };